var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Facebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ea0029;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M632.43,490.39h-2.25v-1.47c0-.56.36-.69.62-.69h1.59V485.8H630.2a2.77,2.77,0,0,0-3,3v1.62h-1.41v2.51h1.41V500h2.95v-7.1h2Z",
    transform: "translate(-617.62 -481.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Facebook);
export default __webpack_public_path__ + "static/media/01_facebook.c12d96e235a88cd78ab98ce9b5ece6e5.svg";
export { ForwardRef as ReactComponent };